<template>
  <div id="influencer_custom_request_decline" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal">
        
        <!-- Header -->
        <div class="modal-header border-0 pb-0 d-flex align-items-center justify-content-between pt-4 px-4">
          <h5 class="modal-title text-white font-weight-500 m-0">Are You Sure?</h5>
          <button type="button" class="close text-white m-0 p-0" data-dismiss="modal" aria-label="Close" style="opacity: 0.8; outline: none;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body text-left pt-4 pb-4 px-4">
          <model-global-message :global-errors="globalErrors" :message="message" @clearMessages="clearMessages()"/>
          
          <div class="mb-4">
            <p class="text-white font-size-14" style="line-height: 1.5; opacity: 0.9;">
              By declining this request, you will no longer be able to change your answer and this request will be deleted.
            </p>
          </div>

          <div class="mb-2">
            <label class="font-size-12 text-muted mb-2 text-uppercase letter-spacing-1 d-block">Reason for decline</label>
            <textarea class="coloredInput2 w-100 text-white p-3" rows="3"
                      placeholder="Reason for decline..."
                      v-model="customRequest.requestDeclineDescription"></textarea>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 d-flex flex-row align-items-center justify-content-end px-4 pb-4 pt-0">
          <button class="btn button-class-danger text-white m-0" @click="decline()" style="color: #ff6b6b !important;">
            Decline
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {influencerCustomRequestMixin} from "@/mixin/influencer-custom-request-mixin";
import {clone} from "@/common/Utils";
import RequiredField from "@/components/module/shared/RequiredField";

export default {
  name: "ModelInfluencerCustomRequestDecline",
  components: {RequiredField},
  mixins: [influencerCustomRequestMixin],
 /* validations: {
    customRequest: {
      requestDeclineDescription: {required},
    }
  },*/
  methods: {
    show(customRequest) {
      this.clearMessages();
      this.customRequest = clone(customRequest);
      $('#influencer_custom_request_decline').modal();
    },
    hide() {
      $('#influencer_custom_request_decline').modal('hide');
    },
    decline() {
     /* this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }*/

      let influencerId = this.customRequest.influencer.id;
      let id = this.customRequest.id;
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${influencerId}/custom-request/${id}/deny-offer`;
      this.patchData(url, this.customRequest, (customRequest) => {
        this.customRequest = customRequest;
        this.hide();
        this.$emit("declinedSuccess");
      });

    }
  }
}
</script>

<style scoped>
.button-class-danger {
    background: rgba(220, 53, 69, 0.15) !important;
    color: #ff6b6b !important;
    border: 1px solid rgba(220, 53, 69, 0.4) !important;
    width: auto !important;
    min-width: 120px !important;
    height: 40px !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.button-class-danger:hover {
    background: rgba(220, 53, 69, 0.25) !important;
    color: #ff6b6b !important;
}
</style>
